import Image from '@components/Image';

import img from './img.png';
import styles from './styles.module.scss';

function PointHeader() {
  return (
        <aside className={styles.container}>
            <div className={styles.card}>
                <Image src={img} alt='포인트 카드'
                width={192}
                height={78} />
            </div>
        </aside>
  );
}

export default PointHeader;
